import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';
import { Questao } from '../../sdk/@types';
import QuestaoService from '../../sdk/services/QuestaoService';

interface QuestaoState {
  list: Questao.Questao[];
  fetching: boolean;
}

const initialState: QuestaoState = {
  list: [],
  fetching: false,
};

export const getTodasAsQuestoes = createAsyncThunk(
  'questao/getTodasAsQuestoes',
  async () => await QuestaoService.getQuestoes()
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getTodasAsQuestoes);
  const error = isRejected(getTodasAsQuestoes);
  const loading = isPending(getTodasAsQuestoes);

  builder
    .addCase(
      getTodasAsQuestoes.fulfilled,
      (state, action) => {
        state.list = action.payload;
      }
    )
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
